export const createStatusOptionsMapper =
  <T extends string>({
    getStatusColor,
    getStatusText,
  }: {
    getStatusColor: (status: T) => string;
    getStatusText: (status: T) => string;
  }) =>
  (statuses: T[]) =>
    statuses.map(status => ({
      label: getStatusText(status),
      value: status,
      color: getStatusColor(status),
    }));
